import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Button, Box, Typography, Chip, Select, MenuItem } from '@mui/material';
import { Link } from 'react-router-dom';
import { getServers, deleteServer } from '../../services/serverService';
import { getHosts } from '../../services/hostService';

const ServerList = () => {
  const [servers, setServers] = useState([]);
  const [hosts, setHosts] = useState([]);
  const [selectedHost, setSelectedHost] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [serversData, hostsData] = await Promise.all([
          getServers(selectedHost || undefined),
          getHosts()
        ]);
        setServers(serversData);
        setHosts(hostsData);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedHost]);

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this server?')) {
      try {
        await deleteServer(id);
        setServers(servers.filter(server => server._id !== id));
      } catch (error) {
        console.error('Error deleting server:', error);
      }
    }
  };

  const columns = [
    { field: 'name', headerName: 'Name', width: 150 },
    { field: 'ip', headerName: 'IP Address', width: 150 },
    {
      field: 'tags',
      headerName: 'Tags',
      width: 200,
      renderCell: (params) => (
        <Box>
          {params.value.map((tag, index) => (
            <Chip key={index} label={tag} size="small" sx={{ mr: 1 }} />
          ))}
        </Box>
      ),
    },
    {
      field: 'host',
      headerName: 'Host',
      width: 200,
      valueGetter: (params) => params.row.host?.name || '',
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 200,
      renderCell: (params) => (
        <Box>
          <Button
            component={Link}
            to={`/servers/edit/${params.row._id}`}
            size="small"
            variant="outlined"
            sx={{ mr: 1 }}
          >
            Edit
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="error"
            onClick={() => handleDelete(params.row._id)}
          >
            Delete
          </Button>
        </Box>
      ),
    },
  ];

  return (
    <Box sx={{ height: 400, width: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h5">Servers</Typography>
        <Box>
          <Select
            value={selectedHost}
            onChange={(e) => setSelectedHost(e.target.value)}
            displayEmpty
            sx={{ mr: 2, minWidth: 200 }}
          >
            <MenuItem value="">All Hosts</MenuItem>
            {hosts.map((host) => (
              <MenuItem key={host._id} value={host._id}>
                {host.name}
              </MenuItem>
            ))}
          </Select>
          <Button component={Link} to="/servers/new" variant="contained">
            Add Server
          </Button>
        </Box>
      </Box>
      <DataGrid
        rows={servers}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5]}
        getRowId={(row) => row._id}
        loading={loading}
      />
    </Box>
  );
};

export default ServerList;